module.exports = __webpack_public_path__ + "assets/on-iot-fault.28fa64ae.svg";